// Luxon/ng necessary polyfills
require('./components/polyfills');

window.$ = require('jquery');
window.jQuery = window.$;

import Dropzone from 'dropzone';
Dropzone.autoDiscover = false;

require('./blade-components/blade-components');
// included here to use preventHintOverflow() function
// prevent hints from overflowing into the footer
let footer = $('.footer');
let footerDefaultMarginTop = parseInt(footer.css('margin-top'));		// footer margin, before being modified by preventHintOverflow()
function preventHintOverflow() {
	let footerHeight = $(document).height() - footer.offset().top + footerDefaultMarginTop;
	let footerMarginTopDiff = parseInt(footer.css('margin-top')) - footerDefaultMarginTop;
	let allHints = Array.prototype.slice.call(document.querySelectorAll('.hint'));
	let preventedHintOverflow = allHints.some(hint => {
		let hintOffsetBottom = $(document).height() - $(hint).offset().top - $(hint).outerHeight() - footerMarginTopDiff;		// minus footerMarginTopDiff to get the offset bottom when the footer has its default height

		if (hintOffsetBottom < footerHeight) {
			let footerNewMarginTop = footerHeight - hintOffsetBottom;
			footer.css('margin-top', (footerDefaultMarginTop + footerNewMarginTop));
			return true;
		}
	});
	if (!preventedHintOverflow) {
		footer.css('margin-top', footerDefaultMarginTop);
	}
}
let hintOverflowTO = undefined;
window.addEventListener('resize', () => {
	clearTimeout(hintOverflowTO);
	hintOverflowTO = setTimeout(function() { preventHintOverflow(); }, 75);
});
// Initially invoke this, in case step 1 info is long (fileupload for example)
setTimeout(() => {
	preventHintOverflow()
}, 500);

require('./components/DiffInput');

import NP_TM from './components/np-tagmanager';
window.tag = new NP_TM({
	additionalEvents: {
		// Landing
		productKashBorgen:	{ event: 'produkt_auswahl_kash_borgen' },
		productKashReserv:	{ event: 'produkt_auswahl_kash_reserv' },
		productIkeaFinance:	{ event: 'produkt_auswahl_ikea_finanzierung' },

		productIkeaCreditCard:	{ event: 'produkt_auswahl_ikea_kreditkarte' },
		productFamilyCard:		{ event: 'produkt_auswahl_ikea_family_bezahlkarte' },
		productMasterCard:		{ event: 'produkt_auswahl_ikea_mastercard_karte' },
		productShoppingCard:	{ event: 'produkt_auswahl_ikea_shopping_card' },

		productIncomeProtection: { event: 'produkt_auswahl_einkommensschutz' },

		// Dynamic event names
		btnNext___placeholder___: { event: '___placeholder____btn_weiter' },
		btnBack___placeholder___: { event: '___placeholder____btn_zurueck' },
		pageCompletion___placeholder___: { event: '___placeholder____vielendank_erreicht' },
		btnCompletion___placeholder___:	{ event: '___placeholder____btn_abschluss' },


		// Einkommensschutz
		incomeProtection_unemplyoment:	{ event: 'einkommensschutz_antrag_arbeitslosigkeit' },
		incomeProtection_disability:	{ event: 'einkommensschutz_antrag_arbeitsunfaehigkeit' },

		backToSelection_Einkommensschutz: { event: 'einkommensschutz_btn_zurueck_uebersicht' },
		backToStart_Einkommensschutz_arbeitslosigkeit:	{ event: 'einkommensschutz_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_Einkommensschutz_arbeitsunfaehigkeit: { event: 'einkommensschutz_arbeitsunfaehigkeit_btn_zurueck_startseite' },		

		// Insured person
		Einkommensschutz_arbeitsunfaehigkeit_no:	{ event: 'einkommensschutz_arbeitsunfaehigkeit_versicherte_person_nein' },
		Einkommensschutz_arbeitsunfaehigkeit_yes:	{ event: 'einkommensschutz_arbeitsunfaehigkeit_versicherte_person_ja' },
		Einkommensschutz_arbeitslosigkeit_no:	{ event: 'einkommensschutz_arbeitslosigkeit_versicherte_person_nein' },
		Einkommensschutz_arbeitslosigkeit_yes:	{ event: 'einkommensschutz_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		Einkommensschutz_arbeitsunfaehigkeit_privacy_clicked: { event: 'einkommensschutz_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		Einkommensschutz_arbeitsunfaehigkeit_obligations_clicked: { event: 'einkommensschutz_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		Einkommensschutz_arbeitslosigkeit_privacy_clicked: { event: 'einkommensschutz_arbeitslosigkeit_datenschutz_akzeptiert' },
		Einkommensschutz_arbeitslosigkeit_obligations_clicked: { event: 'einkommensschutz_arbeitslosigkeit_obliegenheiten_akzeptiert' },

		// checkbox modals
		Einkommensschutz_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'einkommensschutz_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		Einkommensschutz_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'einkommensschutz_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		Einkommensschutz_arbeitslosigkeit_privacy_link_clicked: { event: 'einkommensschutz_arbeitslosigkeit_datenschutzlink_clicked' },
		Einkommensschutz_arbeitslosigkeit_obligations_link_clicked: { event: 'einkommensschutz_arbeitslosigkeit_obliegenheitenlink_clicked' },

		// uploads
		upload_Einkommensschutz_arbeitsunfaehigkeit: { event: 'einkommensschutz_arbeitsunfaehigkeit_dateiupload' },
		upload_Einkommensschutz_arbeitslosigkeit: { event: 'einkommensschutz_arbeitslosigkeit_dateiupload' },


		// Ikano Shopping Card
		shoppingCard_unemplyoment: { event: 'ikea_shopping_card_antrag_arbeitslosigkeit' },
		shoppingCard_disability: { event: 'ikea_shopping_card_antrag_arbeitsunfaehigkeit' },
		shoppingCard_fatality: { event: 'ikea_shopping_card_antrag_todesfall' },

		backToSelection_Ikano_Shopping_Card: { event: 'ikea_shopping_card_btn_zurueck_uebersicht' },
		backToStart_Ikano_Shopping_Card_arbeitslosigkeit: { event: 'ikea_shopping_card_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_Ikano_Shopping_Card_arbeitsunfaehigkeit: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_Ikano_Shopping_Card_todesfall: { event: 'ikea_shopping_card_todesfall_btn_zurueck_startseite' },

		// Insured person
		Ikano_Shopping_Card_arbeitsunfaehigkeit_no: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_versicherte_person_nein' },
		Ikano_Shopping_Card_arbeitsunfaehigkeit_yes: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_versicherte_person_ja' },
		Ikano_Shopping_Card_arbeitslosigkeit_no: { event: 'ikea_shopping_card_arbeitslosigkeit_versicherte_person_nein' },
		Ikano_Shopping_Card_arbeitslosigkeit_yes: { event: 'ikea_shopping_card_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		Ikano_Shopping_Card_arbeitsunfaehigkeit_privacy_clicked: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		Ikano_Shopping_Card_arbeitsunfaehigkeit_obligations_clicked: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		Ikano_Shopping_Card_arbeitslosigkeit_privacy_clicked: { event: 'ikea_shopping_card_arbeitslosigkeit_datenschutz_akzeptiert' },
		Ikano_Shopping_Card_arbeitslosigkeit_obligations_clicked: { event: 'ikea_shopping_card_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		Ikano_Shopping_Card_todesfall_privacy_clicked: { event: 'ikea_shopping_card_todesfall_datenschutz_akzeptiert' },
		Ikano_Shopping_Card_todesfall_obligations_clicked: { event: 'ikea_shopping_card_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		Ikano_Shopping_Card_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		Ikano_Shopping_Card_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		Ikano_Shopping_Card_arbeitslosigkeit_privacy_link_clicked: { event: 'ikea_shopping_card_arbeitslosigkeit_datenschutzlink_clicked' },
		Ikano_Shopping_Card_arbeitslosigkeit_obligations_link_clicked: { event: 'ikea_shopping_card_arbeitslosigkeit_obliegenheitenlink_clicked' },
		Ikano_Shopping_Card_todesfall_privacy_link_clicked: { event: 'ikea_shopping_card_todesfall_datenschutzlink_clicked' },
		Ikano_Shopping_Card_todesfall_obligations_link_clicked: { event: 'ikea_shopping_card_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_Ikano_Shopping_Card_arbeitsunfaehigkeit: { event: 'ikea_shopping_card_arbeitsunfaehigkeit_dateiupload' },
		upload_Ikano_Shopping_Card_arbeitslosigkeit: { event: 'ikea_shopping_card_arbeitslosigkeit_dateiupload' },
		upload_Ikano_Shopping_Card_todesfall: { event: 'ikea_shopping_card_todesfall_dateiupload' },


		// IKEA Family Bezahlkarte
		familyCard_fatality: { event: 'ikea_family_bezahlkarte_antrag_todesfall' },
		familyCard_disability: { event: 'ikea_family_bezahlkarte_antrag_arbeitsunfaehigkeit' },
		familyCard_arbeitslosigkeit: { event: 'ikea_family_bezahlkarte_antrag_arbeitslosigkeit' },

		backToSelection_IKEA_Family_Bezahlkarte: { event: 'ikea_family_bezahlkarte_btn_zurueck_uebersicht' },
		backToStart_IKEA_Family_Bezahlkarte_arbeitslosigkeit: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Family_Bezahlkarte_todesfall: { event: 'ikea_family_bezahlkarte_todesfall_btn_zurueck_startseite' },

		// Insured person
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_no: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_versicherte_person_nein' },
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_yes: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_versicherte_person_ja' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_no: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_versicherte_person_nein' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_yes: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_versicherte_person_ja' },
		// Todesfall has no such question

		// checkboxes
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_privacy_clicked: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_obligations_clicked: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_privacy_clicked: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_datenschutz_akzeptiert' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_obligations_clicked: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		IKEA_Family_Bezahlkarte_todesfall_privacy_clicked: { event: 'ikea_family_bezahlkarte_todesfall_datenschutz_akzeptiert' },
		IKEA_Family_Bezahlkarte_todesfall_obligations_clicked: { event: 'ikea_family_bezahlkarte_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		IKEA_Family_Bezahlkarte_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_privacy_link_clicked: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_datenschutzlink_clicked' },
		IKEA_Family_Bezahlkarte_arbeitslosigkeit_obligations_link_clicked: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_obliegenheitenlink_clicked' },
		IKEA_Family_Bezahlkarte_todesfall_privacy_link_clicked: { event: 'ikea_family_bezahlkarte_todesfall_datenschutzlink_clicked' },
		IKEA_Family_Bezahlkarte_todesfall_obligations_link_clicked: { event: 'ikea_family_bezahlkarte_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_Family_Bezahlkarte_arbeitsunfaehigkeit: { event: 'ikea_family_bezahlkarte_arbeitsunfaehigkeit_dateiupload' },
		upload_Family_Bezahlkarte_arbeitslosigkeit: { event: 'ikea_family_bezahlkarte_arbeitslosigkeit_dateiupload' },
		upload_Family_Bezahlkarte_todesfall: { event: 'ikea_family_bezahlkarte_todesfall_dateiupload' },


		// IKEA Finanzierung
		ikeaFinance_unemployment: { event: 'ikea_finanzierung_antrag_arbeitslosigkeit' },
		ikeaFinance_disability: { event: 'ikea_finanzierung_antrag_arbeitsunfaehigkeit' },
		ikeaFinance_fatality: { event: 'ikea_finanzierung_antrag_todesfall' },

		backToSelection_IKEA_Finanzierung: { event: 'ikea_finanzierung_btn_zurueck_uebersicht' },
		backToStart_IKEA_Finanzierung_arbeitslosigkeit: { event: 'ikea_finanzierung_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Finanzierung_arbeitsunfaehigkeit: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Finanzierung_todesfall: { event: 'ikea_finanzierung_todesfall_btn_zurueck_startseite' },

		// Insured person
		IKEA_Finanzierung_arbeitsunfaehigkeit_no: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_versicherte_person_nein' },
		IKEA_Finanzierung_arbeitsunfaehigkeit_yes: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_versicherte_person_ja' },
		IKEA_Finanzierung_arbeitslosigkeit_no: { event: 'ikea_finanzierung_arbeitslosigkeit_versicherte_person_nein' },
		IKEA_Finanzierung_arbeitslosigkeit_yes: { event: 'ikea_finanzierung_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		IKEA_Finanzierung_arbeitsunfaehigkeit_privacy_clicked: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		IKEA_Finanzierung_arbeitsunfaehigkeit_obligations_clicked: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		IKEA_Finanzierung_arbeitslosigkeit_privacy_clicked: { event: 'ikea_finanzierung_arbeitslosigkeit_datenschutz_akzeptiert' },
		IKEA_Finanzierung_arbeitslosigkeit_obligations_clicked: { event: 'ikea_finanzierung_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		IKEA_Finanzierung_todesfall_privacy_clicked: { event: 'ikea_finanzierung_todesfall_datenschutz_akzeptiert' },
		IKEA_Finanzierung_todesfall_obligations_clicked: { event: 'ikea_finanzierung_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		IKEA_Finanzierung_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		IKEA_Finanzierung_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		IKEA_Finanzierung_arbeitslosigkeit_privacy_link_clicked: { event: 'ikea_finanzierung_arbeitslosigkeit_datenschutzlink_clicked' },
		IKEA_Finanzierung_arbeitslosigkeit_obligations_link_clicked: { event: 'ikea_finanzierung_arbeitslosigkeit_obliegenheitenlink_clicked' },
		IKEA_Finanzierung_todesfall_privacy_link_clicked: { event: 'ikea_finanzierung_todesfall_datenschutzlink_clicked' },
		IKEA_Finanzierung_todesfall_obligations_link_clicked: { event: 'ikea_finanzierung_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_IKEA_Finanzierung_arbeitsunfaehigkeit: { event: 'ikea_finanzierung_arbeitsunfaehigkeit_dateiupload' },
		upload_IKEA_Finanzierung_arbeitslosigkeit: { event: 'ikea_finanzierung_arbeitslosigkeit_dateiupload' },
		upload_IKEA_Finanzierung_todesfall: { event: 'ikea_finanzierung_todesfall_dateiupload' },


		// IKEA Kreditkarte
		ikeaCreditCard_unemplyoment: { event: 'ikea_kreditkarte_antrag_arbeitslosigkeit' },
		ikeaCreditCard_disability: { event: 'ikea_kreditkarte_antrag_arbeitsunfaehigkeit' },
		ikeaCreditCard_fatality: { event: 'ikea_kreditkarte_antrag_todesfall' },
		ikeaCreditCard_illness: { event: 'ikea_kreditkarte_antrag_schwere_krankheit' },
		ikeaCreditCard_aloAssistance: { event: 'ikea_kreditkarte_antrag_alo_assistance' },
		ikeaCreditCard_auAssistance: { event: 'ikea_kreditkarte_antrag_au_assistance' },
		ikeaCreditCard_shopping: { event: 'ikea_kreditkarte_antrag_einkaufs_versicherung' },
		ikeaCreditCard_repair: { event: 'ikea_kreditkarte_antrag_reparatur_versicherung' },
		ikeaCreditCard_ticket: { event: 'ikea_kreditkarte_antrag_ticket_versicherung' },
		ikeaCreditCard_bestPrice: { event: 'ikea_kreditkarte_antrag_best_preis_versicherung' },
		ikeaCreditCard_travel: { event: 'ikea_kreditkarte_antrag_reise_versicherung' },
		ikeaCreditCard_atmRobbery: { event: 'ikea_kreditkarte_antrag_geldautomatenraub' },
		ikeaCreditCard_creditcard_fraud: { event: 'ikea_kreditkarte_antrag_kreditkarten_missbrauch' },
		ikeaCreditCard_pishing: { event: 'ikea_kreditkarte_antrag_phishing_versicherung' },
		ikeaCreditCard_smartphone: { event: 'ikea_kreditkarte_antrag_handy_versicherung' },

		backToSelection_IKEA_Kreditkarte: { event: 'ikea_kreditkarte_btn_zurueck_uebersicht' },
		backToStart_IKEA_Kreditkarte_arbeitslosigkeit: { event: 'ikea_kreditkarte_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_arbeitsunfaehigkeit: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_todesfall: { event: 'ikea_kreditkarte_todesfall_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_schwereKrankheit: { event: 'ikea_kreditkarte_schwere_krankheit_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_einkaufsVersicherung: { event: 'ikea_kreditkarte_einkaufs_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_reparaturVersicherung: { event: 'ikea_kreditkarte_reparatur_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_ticketVersicherung: { event: 'ikea_kreditkarte_ticket_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_bestPreisVersicherung: { event: 'ikea_kreditkarte_best_preis_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_geldAutomatenRaub: { event: 'ikea_kreditkarte_geldautomatenraub_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_kreditkartenMissbrauch: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_phishingVersicherung: { event: 'ikea_kreditkarte_phishing_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_handyVersicherung: { event: 'ikea_kreditkarte_handy_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_reiseschutz: { event: 'ikea_kreditkarte_reise_versicherung_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_aloAssistancen: { event: 'ikea_kreditkarte_alo_assistancen_btn_zurueck_startseite' },
		backToStart_IKEA_Kreditkarte_auAssistancen: { event: 'ikea_kreditkarte_au_assistancen_btn_zurueck_startseite' },

		// Insured person
		IKEA_Kreditkarte_geldAutomatenRaub_no: { event: 'ikea_kreditkarte_geldautomatenraub_versicherte_person_nein' },
		IKEA_Kreditkarte_geldAutomatenRaub_yes: { event: 'ikea_kreditkarte_geldautomatenraub_versicherte_person_ja' },
		IKEA_Kreditkarte_bestPreisVersicherung_no: { event: 'ikea_kreditkarte_best_preis_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_bestPreisVersicherung_yes: { event: 'ikea_kreditkarte_best_preis_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_no: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_versicherte_person_nein' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_yes: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_versicherte_person_ja' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_no: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_versicherte_person_nein' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_yes: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_versicherte_person_ja' },
		IKEA_Kreditkarte_phishingVersicherung_no: { event: 'ikea_kreditkarte_phishing_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_phishingVersicherung_yes: { event: 'ikea_kreditkarte_phishing_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_reparaturVersicherung_no: { event: 'ikea_kreditkarte_reparatur_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_reparaturVersicherung_yes: { event: 'ikea_kreditkarte_reparatur_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_schwereKrankheit_no: { event: 'ikea_kreditkarte_schwere_krankheit_versicherte_person_nein' },
		IKEA_Kreditkarte_schwereKrankheit_yes: { event: 'ikea_kreditkarte_schwere_krankheit_versicherte_person_ja' },
		IKEA_Kreditkarte_einkaufsVersicherung_no: { event: 'ikea_kreditkarte_einkaufs_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_einkaufsVersicherung_yes: { event: 'ikea_kreditkarte_einkaufs_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_handyVersicherung_no: { event: 'ikea_kreditkarte_handy_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_handyVersicherung_yes: { event: 'ikea_kreditkarte_handy_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_ticketVersicherung_no: { event: 'ikea_kreditkarte_ticket_versicherung_versicherte_person_nein' },
		IKEA_Kreditkarte_ticketVersicherung_yes: { event: 'ikea_kreditkarte_ticket_versicherung_versicherte_person_ja' },
		IKEA_Kreditkarte_arbeitslosigkeit_no: { event: 'ikea_kreditkarte_arbeitslosigkeit_versicherte_person_nein' },
		IKEA_Kreditkarte_arbeitslosigkeit_yes: { event: 'ikea_kreditkarte_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		IKEA_Kreditkarte_geldAutomatenRaub_privacy_clicked: { event: 'ikea_kreditkarte_geldautomatenraub_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_geldAutomatenRaub_obligations_clicked: { event: 'ikea_kreditkarte_geldautomatenraub_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_bestPreisVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_best_preis_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_bestPreisVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_best_preis_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_privacy_clicked: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_obligations_clicked: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_privacy_clicked: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_obligations_clicked: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_phishingVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_phishing_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_phishingVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_phishing_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_reparaturVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_reparatur_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_reparaturVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_reparatur_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_schwereKrankheit_privacy_clicked: { event: 'ikea_kreditkarte_schwere_krankheit_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_schwereKrankheit_obligations_clicked: { event: 'ikea_kreditkarte_schwere_krankheit_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_einkaufsVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_einkaufs_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_einkaufsVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_einkaufs_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_handyVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_handy_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_handyVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_handy_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_ticketVersicherung_privacy_clicked: { event: 'ikea_kreditkarte_ticket_versicherung_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_ticketVersicherung_obligations_clicked: { event: 'ikea_kreditkarte_ticket_versicherung_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_arbeitslosigkeit_privacy_clicked: { event: 'ikea_kreditkarte_arbeitslosigkeit_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_arbeitslosigkeit_obligations_clicked: { event: 'ikea_kreditkarte_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		IKEA_Kreditkarte_todesfall_privacy_clicked: { event: 'ikea_kreditkarte_todesfall_datenschutz_akzeptiert' },
		IKEA_Kreditkarte_todesfall_obligations_clicked: { event: 'ikea_kreditkarte_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		IKEA_Kreditkarte_geldAutomatenRaub_privacy_link_clicked: { event: 'ikea_kreditkarte_geldautomatenraub_datenschutzlink_clicked' },
		IKEA_Kreditkarte_geldAutomatenRaub_obligations_link_clicked: { event: 'ikea_kreditkarte_geldautomatenraub_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_bestPreisVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_best_preis_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_bestPreisVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_best_preis_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_privacy_link_clicked: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_datenschutzlink_clicked' },
		IKEA_Kreditkarte_kreditkartenMissbrauch_obligations_link_clicked: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		IKEA_Kreditkarte_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_phishingVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_phishing_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_phishingVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_phishing_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_reparaturVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_reparatur_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_reparaturVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_reparatur_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_schwereKrankheit_privacy_link_clicked: { event: 'ikea_kreditkarte_schwere_krankheit_datenschutzlink_clicked' },
		IKEA_Kreditkarte_schwereKrankheit_obligations_link_clicked: { event: 'ikea_kreditkarte_schwere_krankheit_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_einkaufsVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_einkaufs_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_einkaufsVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_einkaufs_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_handyVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_handy_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_handyVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_handy_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_ticketVersicherung_privacy_link_clicked: { event: 'ikea_kreditkarte_ticket_versicherung_datenschutzlink_clicked' },
		IKEA_Kreditkarte_ticketVersicherung_obligations_link_clicked: { event: 'ikea_kreditkarte_ticket_versicherung_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_arbeitslosigkeit_privacy_link_clicked: { event: 'ikea_kreditkarte_arbeitslosigkeit_datenschutzlink_clicked' },
		IKEA_Kreditkarte_arbeitslosigkeit_obligations_link_clicked: { event: 'ikea_kreditkarte_arbeitslosigkeit_obliegenheitenlink_clicked' },
		IKEA_Kreditkarte_todesfall_privacy_link_clicked: { event: 'ikea_kreditkarte_todesfall_datenschutzlink_clicked' },
		IKEA_Kreditkarte_todesfall_obligations_link_clicked: { event: 'ikea_kreditkarte_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_IKEA_Kreditkarte_geldAutomatenRaub: { event: 'ikea_kreditkarte_geldautomatenraub_dateiupload' },
		upload_IKEA_Kreditkarte_bestPreisVersicherung: { event: 'ikea_kreditkarte_best_preis_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_kreditkartenMissbrauch: { event: 'ikea_kreditkarte_kreditkarten_missbrauch_dateiupload' },
		upload_IKEA_Kreditkarte_arbeitsunfaehigkeit: { event: 'ikea_kreditkarte_arbeitsunfaehigkeit_dateiupload' },
		upload_IKEA_Kreditkarte_phishingVersicherung: { event: 'ikea_kreditkarte_phishing_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_reparaturVersicherung: { event: 'ikea_kreditkarte_reparatur_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_schwereKrankheit: { event: 'ikea_kreditkarte_schwere_krankheit_dateiupload' },
		upload_IKEA_Kreditkarte_einkaufsVersicherung: { event: 'ikea_kreditkarte_einkaufs_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_handyVersicherung: { event: 'ikea_kreditkarte_handy_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_ticketVersicherung: { event: 'ikea_kreditkarte_ticket_versicherung_dateiupload' },
		upload_IKEA_Kreditkarte_arbeitslosigkeit: { event: 'ikea_kreditkarte_arbeitslosigkeit_dateiupload' },
		upload_IKEA_Kreditkarte_todesfall: { event: 'ikea_kreditkarte_todesfall_dateiupload' },


		// Kash Borgen Ratenkredit
		kashBorgen_unemployment: { event: 'kash_borgen_antrag_arbeitslosigkeit' },
		kashBorgen_disability: { event: 'kash_borgen_antrag_arbeitsunfaehigkeit' },
		kashBorgen_fatality: { event: 'kash_borgen_antrag_todesfall' },

		backToSelection_Kash_Borgen_Ratenkredit: { event: 'kash_borgen_btn_zurueck_uebersicht' },
		backToStart_Kash_Borgen_Ratenkredit_arbeitslosigkeit: { event: 'kash_borgen_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit: { event: 'kash_borgen_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_Kash_Borgen_Ratenkredit_todesfall: { event: 'kash_borgen_todesfall_btn_zurueck_startseite' },

		// Insured person
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_no: { event: 'kash_borgen_arbeitsunfaehigkeit_versicherte_person_nein' },
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_yes: { event: 'kash_borgen_arbeitsunfaehigkeit_versicherte_person_ja' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_no: { event: 'kash_borgen_arbeitslosigkeit_versicherte_person_nein' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_yes: { event: 'kash_borgen_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_privacy_clicked: { event: 'kash_borgen_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_obligations_clicked: { event: 'kash_borgen_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_privacy_clicked: { event: 'kash_borgen_arbeitslosigkeit_datenschutz_akzeptiert' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_obligations_clicked: { event: 'kash_borgen_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		Kash_Borgen_Ratenkredit_todesfall_privacy_clicked: { event: 'kash_borgen_todesfall_datenschutz_akzeptiert' },
		Kash_Borgen_Ratenkredit_todesfall_obligations_clicked: { event: 'kash_borgen_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'kash_borgen_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'kash_borgen_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_privacy_link_clicked: { event: 'kash_borgen_arbeitslosigkeit_datenschutzlink_clicked' },
		Kash_Borgen_Ratenkredit_arbeitslosigkeit_obligations_link_clicked: { event: 'kash_borgen_arbeitslosigkeit_obliegenheitenlink_clicked' },
		Kash_Borgen_Ratenkredit_todesfall_privacy_link_clicked: { event: 'kash_borgen_todesfall_datenschutzlink_clicked' },
		Kash_Borgen_Ratenkredit_todesfall_obligations_link_clicked: { event: 'kash_borgen_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_Kash_Borgen_Ratenkredit_arbeitsunfaehigkeit: { event: 'kash_borgen_arbeitsunfaehigkeit_dateiupload' },
		upload_Kash_Borgen_Ratenkredit_arbeitslosigkeit: { event: 'kash_borgen_arbeitslosigkeit_dateiupload' },
		upload_Kash_Borgen_Ratenkredit_todesfall: { event: 'kash_borgen_todesfall_dateiupload' },


		// Kash Reserv Rahmenkredit
		kashReserv_unemployment: { event: 'kash_reserv_antrag_arbeitslosigkeit' },
		kashReserv_disability: { event: 'kash_reserv_antrag_arbeitsunfaehigkeit' },
		kashReserv_fatality: { event: 'kash_reserv_antrag_todesfall' },
		kashReserv_illness: { event: 'kash_reserv_antrag_schwere_krankheit' },
		kashReserv_aloAssistance: { event: 'kash_reserv_antrag_alo_assistance' },
		kashReserv_auAssistance: { event: 'kash_reserv_antrag_au_assistance' },

		backToSelection_Kash_Reserv_Rahmenkredit: { event: 'kash_reserv_btn_zurueck_uebersicht' },
		backToStart_Kash_Reserv_Rahmenkredit_arbeitslosigkeit: { event: 'kash_reserv_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit: { event: 'kash_reserv_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_Kash_Reserv_Rahmenkredit_todesfall: { event: 'kash_reserv_todesfall_btn_zurueck_startseite' },
		backToStart_Kash_Reserv_Rahmenkredit_schwereKrankheit: { event: 'kash_reserv_schwere_krankheit_btn_zurueck_startseite' },
		backToStart_Kash_Reserv_Rahmenkredit_aloAssistancen: { event: 'kash_reserv_alo_assistancen_btn_zurueck_startseite' },
		backToStart_Kash_Reserv_Rahmenkredit_auAssistancen: { event: 'kash_reserv_au_assistancen_btn_zurueck_startseite' },

		// Insured person
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_no: { event: 'kash_reserv_arbeitsunfaehigkeit_versicherte_person_nein' },
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_yes: { event: 'kash_reserv_arbeitsunfaehigkeit_versicherte_person_ja' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_no: { event: 'kash_reserv_arbeitslosigkeit_versicherte_person_nein' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_yes: { event: 'kash_reserv_arbeitslosigkeit_versicherte_person_ja' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_no: { event: 'kash_reserv_schwere_krankheit_versicherte_person_nein' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_yes: { event: 'kash_reserv_schwere_krankheit_versicherte_person_ja' },

		// checkboxes
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_privacy_clicked: { event: 'kash_reserv_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_obligations_clicked: { event: 'kash_reserv_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_privacy_clicked: { event: 'kash_reserv_arbeitslosigkeit_datenschutz_akzeptiert' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_obligations_clicked: { event: 'kash_reserv_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_privacy_clicked: { event: 'kash_reserv_schwere_krankheit_datenschutz_akzeptiert' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_obligations_clicked: { event: 'kash_reserv_schwere_krankheit_obliegenheiten_akzeptiert' },
		Kash_Reserv_Rahmenkredit_todesfall_privacy_clicked: { event: 'kash_reserv_todesfall_datenschutz_akzeptiert' },
		Kash_Reserv_Rahmenkredit_todesfall_obligations_clicked: { event: 'kash_reserv_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'kash_reserv_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'kash_reserv_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_privacy_link_clicked: { event: 'kash_reserv_arbeitslosigkeit_datenschutzlink_clicked' },
		Kash_Reserv_Rahmenkredit_arbeitslosigkeit_obligations_link_clicked: { event: 'kash_reserv_arbeitslosigkeit_obliegenheitenlink_clicked' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_privacy_link_clicked: { event: 'kash_reserv_schwere_krankheit_datenschutzlink_clicked' },
		Kash_Reserv_Rahmenkredit_schwereKrankheit_obligations_link_clicked: { event: 'kash_reserv_schwere_krankheit_obliegenheitenlink_clicked' },
		Kash_Reserv_Rahmenkredit_todesfall_privacy_link_clicked: { event: 'kash_reserv_todesfall_datenschutzlink_clicked' },
		Kash_Reserv_Rahmenkredit_todesfall_obligations_link_clicked: { event: 'kash_reserv_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_Kash_Reserv_Rahmenkredit_arbeitsunfaehigkeit: { event: 'kash_reserv_arbeitsunfaehigkeit_dateiupload' },
		upload_Kash_Reserv_Rahmenkredit_arbeitslosigkeit: { event: 'kash_reserv_arbeitslosigkeit_dateiupload' },
		upload_Kash_Reserv_Rahmenkredit_schwereKrankheit: { event: 'kash_reserv_schwere_krankheit_dateiupload' },
		upload_Kash_Reserv_Rahmenkredit_todesfall: { event: 'kash_reserv_todesfall_dateiupload' },


		// Rote MasterCard
		redMastercard_unemployment: { event: 'ikea_mastercard_karte_antrag_arbeitslosigkeit' },
		redMastercard_disability: { event: 'ikea_mastercard_karte_antrag_arbeitsunfaehigkeit' },
		redMastercard_fatality: { event: 'ikea_mastercard_karte_antrag_todesfall' },

		backToSelection_Rote_Mastercard_Karte: { event: 'ikea_mastercard_karte_btn_zurueck_uebersicht' },
		backToStart_Rote_Mastercard_Karte_arbeitslosigkeit: { event: 'ikea_mastercard_karte_arbeitslosigkeit_btn_zurueck_startseite' },
		backToStart_Rote_Mastercard_Karte_arbeitsunfaehigkeit: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_btn_zurueck_startseite' },
		backToStart_Rote_Mastercard_Karte_todesfall: { event: 'ikea_mastercard_karte_todesfall_btn_zurueck_startseite' },

		// Insured person
		Rote_Mastercard_Karte_Rahmenkredit_arbeitsunfaehigkeit_no: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_versicherte_person_nein' },
		Rote_Mastercard_Karte_Rahmenkredit_arbeitsunfaehigkeit_yes: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_versicherte_person_ja' },
		Rote_Mastercard_Karte_Rahmenkredit_arbeitslosigkeit_no: { event: 'ikea_mastercard_karte_arbeitslosigkeit_versicherte_person_nein' },
		Rote_Mastercard_Karte_Rahmenkredit_arbeitslosigkeit_yes: { event: 'ikea_mastercard_karte_arbeitslosigkeit_versicherte_person_ja' },

		// checkboxes
		Rote_Mastercard_Karte_arbeitsunfaehigkeit_privacy_clicked: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_datenschutz_akzeptiert' },
		Rote_Mastercard_Karte_arbeitsunfaehigkeit_obligations_clicked: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_obliegenheiten_akzeptiert' },
		Rote_Mastercard_Karte_arbeitslosigkeit_privacy_clicked: { event: 'ikea_mastercard_karte_arbeitslosigkeit_datenschutz_akzeptiert' },
		Rote_Mastercard_Karte_arbeitslosigkeit_obligations_clicked: { event: 'ikea_mastercard_karte_arbeitslosigkeit_obliegenheiten_akzeptiert' },
		Rote_Mastercard_Karte_todesfall_privacy_clicked: { event: 'ikea_mastercard_karte_todesfall_datenschutz_akzeptiert' },
		Rote_Mastercard_Karte_todesfall_obligations_clicked: { event: 'ikea_mastercard_karte_todesfall_obliegenheiten_akzeptiert' },

		// checkbox modals
		Rote_Mastercard_Karte_arbeitsunfaehigkeit_privacy_link_clicked: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_datenschutzlink_clicked' },
		Rote_Mastercard_Karte_arbeitsunfaehigkeit_obligations_link_clicked: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_obliegenheitenlink_clicked' },
		Rote_Mastercard_Karte_arbeitslosigkeit_privacy_link_clicked: { event: 'ikea_mastercard_karte_arbeitslosigkeit_datenschutzlink_clicked' },
		Rote_Mastercard_Karte_arbeitslosigkeit_obligations_link_clicked: { event: 'ikea_mastercard_karte_arbeitslosigkeit_obliegenheitenlink_clicked' },
		Rote_Mastercard_Karte_todesfall_privacy_link_clicked: { event: 'ikea_mastercard_karte_todesfall_datenschutzlink_clicked' },
		Rote_Mastercard_Karte_todesfall_obligations_link_clicked: { event: 'ikea_mastercard_karte_todesfall_obliegenheitenlink_clicked' },

		// uploads
		upload_Rote_Mastercard_Karte_arbeitsunfaehigkeit: { event: 'ikea_mastercard_karte_arbeitsunfaehigkeit_dateiupload' },
		upload_Rote_Mastercard_Karte_arbeitslosigkeit: { event: 'ikea_mastercard_karte_arbeitslosigkeit_dateiupload' },
		upload_Rote_Mastercard_Karte_todesfall: { event: 'ikea_mastercard_karte_todesfall_dateiupload' },
	}
});

// Progressbar handling
import ProgressBar from './components/ProgressBar';
if (document.querySelector('.js-progress')) {
	window.Progress = ProgressBar();
}

import Validation from './components/Validation';
/**
 * Gets Validation instance via trigger on an element.
 * Returns the first element's validation found.
 */
let getVI = function(trigger) {
	try {
		return Validation.prototype.getInstanceById(
			document.querySelector(`[validate-trigger="${ trigger }"]`).getAttribute('validation')
		);
	} catch (e) {
		return undefined;
	}
};

import FileUploadStatus from './components/FileUploadStatus';
let fuStatus = new FileUploadStatus({
	statusContainer: document.querySelector('.js-file-status'),
	statusMessage: document.querySelector('.js-file-status .js-file-status-message'),
	progressBar: document.querySelector('.js-file-status .js-progress'),
});
window.channel = require('./components/Channel')();

const { DateTime } = require('luxon');
let angular = require('angular');

let csrf_token = document.head.querySelector('meta[name=csrf-token]').getAttribute('content');
let app = angular.module('npSPA', [  ]);
app.controller('AppCtrl', [ '$timeout', '$http', function($timeout, $http) {
	this.config = {
		maxSteps: {
			arbeitslosigkeit: 5,
			arbeitsunfaehigkeit: 5,
			bestPreisVersicherung: 5,
			einkaufsVersicherung: 5,
			geldAutomatenRaub: 5,
			handyVersicherung: 5,
			kreditkartenMissbrauch: 5,
			phishingVersicherung: 5,
			reparaturVersicherung: 5,
			schwereKrankheit: 5,
			ticketVersicherung: 5,
			todesfall: 5,

			aloAssistancen: 1,
			auAssistancen: 1,
			reiseschutz: 1,
		},
		selectedDamage: undefined,

		currentStep: 0,
		skipInsuredPersonCtrl: false,  // if client say they are the insured person, we skip InsuredPersonCtrl
		mapDamageToController: {
			//aloAssistancen: [  ],auAssistancen: [  ],reiseschutz: [  ],

			arbeitslosigkeit: [ 'UnemploymentCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			arbeitsunfaehigkeit: [ 'DisabilityCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			bestPreisVersicherung: [ 'BestPriceCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			einkaufsVersicherung: [ 'ShoppingCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			geldAutomatenRaub: [ 'ATMRobberyCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			handyVersicherung: [ 'HandyCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			kreditkartenMissbrauch: [ 'CreditFraudCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			phishingVersicherung: [ 'PhishingCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			reparaturVersicherung: [ 'RepairCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			schwereKrankheit: [ 'IllnessCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			ticketVersicherung: [ 'TicketCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
			todesfall: [ 'FatalityCtrl', 'InsuredPersonCtrl', 'PersonalCtrl', 'ConsentCtrl' ],
		},
		mapProductToEvent: {
			Ikano_Shopping_Card:		'ikea_shopping_card',
			Kash_Borgen_Ratenkredit:	'kash_borgen',
			Kash_Reserv_Rahmenkredit:	'kash_reserv', 
			Rote_Mastercard_Karte:		'ikea_mastercard_karte'
		},
		mapDamageToEvent: {
			schwereKrankheit:		'schwere_krankheit',
			einkaufsVersicherung:	'einkaufs_versicherung',
			reparaturVersicherung:	'reparatur_versicherung',
			ticketVersicherung:		'ticket_versicherung',
			bestPreisVersicherung:	'best_preis_versicherung',
			geldAutomatenRaub:		'geldautomatenraub',
			kreditkartenMissbrauch:	'kreditkarten_missbrauch',
			phishingVersicherung: 	'phishing_versicherung',
			handyVersicherung:		'handy_versicherung',
			reiseschutz:			'reise_versicherung',
			aloAssistancen:			'alo_assistancen',
			auAssistancen:			'au_assistancen',
		},
		sendingComplaint: false,
		checkingValidity: false,
		complaintError: undefined,
	};

	this.data = {
		// dynamically filled later on
	};

	// Tag Manager Tracking, here and in template
	this.tagmanager = id => {
		tag.push(id);
	};

	this.getStepEventTitle = () => {
		return [ '', 'schadenmeldung', 'versicherteperson', 'persoenlichedaten', 'hinweis' ][this.config.currentStep] ?? '';
	};
	this.getProductEvent = product => {
		return this.config.mapProductToEvent[product] ?? product.toLocaleLowerCase();
	};
	this.getDamageEvent = damage => {
		return this.config.mapDamageToEvent[damage] ?? damage.toLocaleLowerCase();
	};

	let uploadEventsInitialized = false;
	this.sendComplaint = async () => {
		await this.setState(() => {
			this.config.sendingComplaint = true;
			this.config.checkingValidity = false;
		});
		this.tagmanager(`btnCompletion___${ this.getProductEvent(selectedProduct)  }_${ this.getDamageEvent(selectedDamage) }___`);

		let fileUploads = 0;
		if (!uploadEventsInitialized) {
			channel.register('file_upload_completed', () => {		
				--fileUploads;
				if (fileUploads <= 0) {
					this.sendComplaintAjax();
				}
			});
			channel.register('file_upload_done', file => {
				fuStatus.finished(file.name);
			});
			channel.register('file_upload_sending', file => {
				fuStatus.uploading(file.name);
			});

			uploadEventsInitialized = true;
		}

		// We do not know how many file upload components there are, nor how many files to upload
		// -> send a notification to upload files to all file uploads available
		// -> wait for file_upload_completed events from those uploads and decrease number of file uploads to complete
		// -> if 0 is reached send ajax request
		let filesToUpload = await channel.notify('upload_files');

		// The amount of fileuploads that need to upload (multiple) files - this number is decreased on event file_upload_completed
		fileUploads = (filesToUpload.filter(v => v > 0)).length;

		// the amount of files to upload in total through all file uploads
		filesToUpload = filesToUpload.reduce((v, prev) => prev+v, 0);
		fuStatus.setTotalFiles(filesToUpload);

		if (filesToUpload === 0) {
			this.sendComplaintAjax();
		}
	};

	this.sendComplaintAjax = async () => {
		await $http({
			method: 'POST',
			url: ROUTES.complaint,
			data: this.data,
			headers: {
				'X-CSRF-TOKEN': csrf_token,
				'X-GLOBALID': __GLOBALID
			}
		}).then(resp => {
			let json = resp.data;
			if (!json.error) {
				this.setState(() => {
					this.config.complaintError = undefined;
					this.config.sendingComplaint = false

					Progress.setVisibility(this.config.currentStep, false);
					this.config.currentStep += 1;
					Progress.setVisibility(this.config.currentStep, true);
					Progress.set(this.config.currentStep);

					this.tagmanager(`pageCompletion___${ this.getProductEvent(selectedProduct) }_${ this.getDamageEvent(selectedDamage) }___`);

					setTimeout(() => {
						window.scrollTo(0, 0);
						preventHintOverflow();
					}, 50);
				});
			} else {
				this.setState(() => {
					this.config.complaintError = json.message;
					this.config.sendingComplaint = false;
				});

			}
		}).catch(resp => {
			this.setState(() => {
				this.config.complaintError = resp.data.message;
				this.config.sendingComplaint = false;
			});
		});
	};

	this.downloadReport = () => {
		let a = document.createElement('a');
			a.setAttribute('href', ROUTES.downloadReport.replace('#id#', __GLOBALID));
			a.setAttribute('target', '_blank');
			a.setAttribute('rel', 'noopener noreferrer');
			a.setAttribute('class', 'hidden');
		document.body.appendChild(a);
		a.click();
		a.remove();
	};

	/**
	 * Sets the state of ng variables.
	 * Triggers a digest cycle by using $timeout.
	 *
	 * @param	function	func	A function to execute.
	 * @param	integer		delay	Optional delay for when to exec func.
	 */
	this.setState = async(func, delay) => {
		return await $timeout((typeof(delay) !== 'undefined' ? delay : 0)).then(func);
	};

	this.tmpl = {
		isSelected: key => this.config.selectedDamage === key,
		isStep: step => this.config.currentStep === step,
		select: damage => {
			this.setState(() => {
				this.config.selectedDamage = damage;

				let breadcrumbProduct = document.querySelector('.js-breadcrumb-product');
				let breadcrumbDamage = document.querySelector('.js-breadcrumb-damage');

				breadcrumbDamage.innerHTML = mapDamages[damage];
				breadcrumbProduct.classList.remove('breadcrumb__item--active');
				breadcrumbDamage.classList.add('breadcrumb__item--active');

				Progress.set(this.config.currentStep);
				setTimeout(() => {
					window.scrollTo(0, 0);
					preventHintOverflow();
				}, 50);
			});
		},
		back: () => {
			this.setState(() => {
				if (this.config.currentStep === 1) {
					this.tagmanager(`btnBack___${ selectedProduct }_${ selectedDamage }_${ this.getStepEventTitle() }___`);
					location.href = ROUTES.overview;
					return;
				}

				this.tagmanager(`btnBack___${ this.getProductEvent(selectedProduct) }_${ this.getDamageEvent(selectedDamage) }_${ this.getStepEventTitle() }___`);

				// Previously, we skipped this step, so skip again
				if (this.config.currentStep === 3 && this.config.skipInsuredPersonCtrl) {
					this.config.currentStep -= 2;
				} else {
					--this.config.currentStep;
				}

				Progress.set(this.config.currentStep);
				setTimeout(() => {
					window.scrollTo(0, 0);
					preventHintOverflow();
				}, 50);
			});
		},
		next: async () => {
			await this.setState(() => this.config.checkingValidity = true);

			// Validate current step and abort of not valid
			// step 0 is selection, hence -1 to determine currently active controller
			let currentController = this.config.mapDamageToController[this.config.selectedDamage][this.config.currentStep-1];
			let validationResult = await channel.notify(`${ currentController }_validate`);
			if (validationResult[0] == false) {
				this.setState(() => this.config.checkingValidity = false, 500);
				return;
			}

			// Check if we need to skip the InsurancePerson step
			let nextStep = this.config.currentStep + 1;
			if (this.config.currentStep === 1) {
				validationResult = await channel.notify(`${ currentController }_insuredPerson`);
				if (validationResult[0] === true) {  // skip "Angaben zur versicherten Person"
					nextStep += 1;

					this.config.skipInsuredPersonCtrl = true;
					Progress.setVisibility(2, false);

					await channel.notify(`PersonalCtrl_displayBank`, true);
					await channel.notify(`InsuredPersonCtrl_displayBank`, false);
				} else {
					this.config.skipInsuredPersonCtrl = false;
					Progress.setVisibility(2, true);

					await channel.notify(`PersonalCtrl_displayBank`, false);
					await channel.notify(`InsuredPersonCtrl_displayBank`, true);
				}
			}

			// check if this is the contract completion step, where we need to send data to server
			if (this.config.currentStep+1 === this.config.maxSteps[this.config.selectedDamage]) {
				let data = await channel.notify(`data_collection`);
				data.forEach(entry => {
					this.data[entry.ctrl] = entry.data;
				});

				this.sendComplaint();
				return;
			}

			this.tagmanager(`btnNext___${ this.getProductEvent(selectedProduct) }_${ this.getDamageEvent(selectedDamage) }_${ this.getStepEventTitle() }___`);
			this.setState(() => {
				this.config.checkingValidity = false;
				this.config.currentStep = nextStep;
				Progress.set(nextStep);

				setTimeout(() => {
					window.scrollTo(0, 0);
					preventHintOverflow();
				}, 50);
			}, 500);
		},
	};

	this.main = () => {
		Validation.prototype.addRule('birthday', function(input) {
			if (input == '..') { return false; }

			try {
				// years will be negative
				let age = -1*DateTime.fromFormat(`${ input } 00:00:00`, 'dd.MM.yyyy HH:mm:ss').diffNow('years').years;
				if (Number.isNaN(age) || age < 18 || age > 65) {
					return false;
				}
			} catch (e) {
				return false;
			}

			return true;
		});

		Validation.prototype.addRule('salutation', function(input) {
			return input == 'm' || input == 'f';
		});

		Validation.prototype.addRule('damageNature', function(input) {
			return input == 'robbery' || input == 'damage';
		});

		// Nonempty for radio means, any of the grouped radios must be checked
		Validation.prototype.addRule('radio_nonEmpty', function(input, element) {
			let container = element.closest('.input__container');
			if (container) {
				let radios = Array.prototype.slice.call(container.querySelectorAll('input[type="radio"]'));

				return radios.some(el => el.checked);
			}
			return false;
		});

		Validation.prototype.addRule('date', function(input) {
			if (input == '..') { return false; }

			try {
				let date = DateTime.fromFormat(`${ input } 00:00:00`, 'dd.MM.yyyy HH:mm:ss');

				if (Number.isNaN(date) || !date.isValid) {
					return false;
				}
			} catch (e) {
				return false;
			}

			return true;
		});

		Validation.prototype.addRule('customIban', function(input, element) {
			if (!input.replace(/ /g, '').match(/^\D{2}\d{20}$/i)) { return false; }
			if (element.getAttribute('checking-iban') === 'true') { return false; }  // api check ongoing

			let prop = element.getAttribute('valid-iban');
			if (!prop || prop !== 'true') {
				return false;
			}

			return true;
		});

		Validation.prototype.reset = function() {
			// we cannot use toggleHighlight(false) or we'll get a checkmark on inputs
			let parent = this.data.element.closest('.input__container');
			if (!parent) { return; }
			parent.classList.remove(this.config.errorClass);
			
			// We need to fake a true state for this element's validation to reset error states
			this.data.element.dispatchEvent(
				new CustomEvent('validationResult', {
					detail: { isValid: true, currentValue: this.getCurrentValue() },
					bubbles: true, cancelable: true
				})
			);
		};

		// Validation: Displaying the correct error messages
		// if any of these rules return true the error message must be displayed
		let errorRules = {
			empty:			v => !v.length,
			len5:			v => v.length != 5,
			len22:			v => v.length != 22,
			mail:			v => v.length != 0 && !v.match(/^[a-z0-9_\\-\\.]+@[a-z0-9_\\-\\.]+\\.[a-z0-9]+$/i),
			ibanFormat:		v => !v.replace(/ /g, '').match(/^\D{2}\d{20}$/i),
			ibanInvalid:	v => document.querySelector('#input--text-iban').getAttribute('valid-iban') !== 'true',
			checked:		v => v != true,
			dateEmpty:		v => v === '..',
			date: 			v => {
								if (v === '..') { return false; }
								let date = DateTime.fromFormat(`${ v } 00:00:00`, 'dd.MM.yyyy HH:mm:ss');
								if (Number.isNaN(date) || !date.isValid) {
									return true;
								}
								return false;
							},
			salutation:		v => {
				return v !== 'm' && v !== 'f';
			},
			phoneInvalid:	v => v.match(/[^0-9]/i)
		};
		/**
		 * This is the connection between errors and (validaton) rules
		 * The index of the error inside the error range in the template defines the accompanying rule in this map.
		 *
		 * Example, a form element with these errors:
		 * [
		 * 		[ 'error' => 'title', 'content' => 'Input too short' ],
		 * 		[ 'error' => 'title', 'content' => 'Input too long' ],
		 * ]
		 *
		 * We have two errors -> tooShort, tooLong.
		 * How do we decide what error to display via Validation.js?
		 *
		 * In mapFormElements we map the element(s) that have those two errors defined.
		 * We do this either via full, absolute IDs, or via a regular expression that applies to multiple elements.
		 * mapFormElements = [ 'input--text--.*':  [ 'tooShort', 'tooLong' ] ];
		 * This expression matches multiple element ids, all beginning with "input--text--".
		 *
		 * Now, whenever Validation triggers on any element that has the id "input--text--XXX",
		 * Validation will try to figure out what error to display (if at all) by looking into this mapFormElements.
		 * That means mapFormElements[validatedElementsId] which returns [ tooShort, tooLong ] in this example for element with id input--text--*.
		 *
		 * But what is tooShort/tooLong? Just two strings. They have no meaning to Validation.
		 * That's why we have errorRules above.
		 * In that we define rules that when they return true it means the error message must be displayed.
		 *
		 * errorRules['tooShort'] = v => v.length < 1;
		 * errorRules['tooLong'] = v => v.length > 10;
		 *
		 * Validation.js will take the result of mapFormElements[validatedElementsId] -> [ tooShort, tooLong ]
		 * Loop through that result and for each element execute errorRules[rule](valueOfValidatedElement) until one function returns true.
		 * In this example if errorRules['tooLong'](value) returns true because the input is too long,
		 * we know we must display the second error message.
		 */
		let mapFormElements = {
			'default':						[ 'empty' ],  // currently only one possible error, fallback error message
			'input--text-.+?-step-.+?-contract-number': [ 'empty' ],
			'input--text-.+?-date':			[ 'date' ],
			'input--text-.+?-zip':			[ 'empty', 'len5' ],
			'input--text-.+?-phone': 		[ 'empty', 'phoneInvalid' ],
			'input--text-.+?-mail': 		[ 'empty', 'mail'],
		};
		let mapKeys = Object.keys(mapFormElements);
		for (let i = 0; i < mapKeys.length; ++i) {
			mapKeys[i] = { re: new RegExp(mapKeys[i]), key: mapKeys[i] };
		}

		// we need to connect the file uploads with regular input validation to hide/display hints/errors
		let validUploads = async () => {
			let resp = await channel.notify('uploads_valid');
			if (resp === undefined) {
				// no uploads available
				resp = [true];
			}
			// check through all responses for true response
			return resp.every(resp => resp === true);
		};
		// Extending Validation instance for our hint/error handling
		let initFunc = that => {
			// Fetch parent container and look for the hint, if this container isn't available and null
			// we encountered an edge case to fix
			let parent = that.data.element.closest('.input__container');
			let hintInitial = parent.querySelector('.hint.hint--view-option-initial');
			let formComponentsContainer = that.data.element.closest('.form-components-container');
			let errorContainer = parent.querySelector('.input__error-container');

			// if the input is invalid, we need to display the error message
			// but not the hint while focus
			that.data.element.addEventListener('validationResult', async(e) => {
				// Figure out what error message must be displayed
				if (!e.detail.isValid && that.config.errors.length > 0) {

					let vu = await validUploads();
					if (formComponentsContainer && (!formComponentsContainer.classList.contains('hide-hints') || !vu)) {
						formComponentsContainer.classList.add('hide-hints');
					}

					if (hintInitial) {
						hintInitial.classList.add('hidden');
					}

					let id = that.data.element.getAttribute('id');
					let foundKey = undefined;
					mapKeys.some(entry => {
						if (id.match(entry.re)) {
							foundKey = entry.key;
							return true;
						}

						return false;
					});

					// This element does not have its own rule, so use 'default'
					if (foundKey === undefined) {
						if (that.config.errors.length) {
							that.config.lastDisplayedError = 0;
							errorContainer && errorContainer.setAttribute('data-error', 'active-0');
						}
					} else {
						mapFormElements[foundKey].some((key, i) => {
							if (errorRules[key](e.detail.currentValue)) {
								that.config.lastDisplayedError = i;
								errorContainer && errorContainer.setAttribute('data-error', 'active-'+ i);

								// We validate a compound date field, we need to apply the error class somewhere else
								if (key === 'date') {
									// we need to hide potentially previously displayed errors, as we have no blur event here
									that.config.errors.forEach(err => err.classList.add('hidden'));
									that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
									that.data.element.closest('.js-compound-container').classList.add('invalid-input');
								}
								return true;
							}

							return false;
						});
					}

					// Display errors for non-blur/focusable form elements
					switch(that.data.element.nodeName.toLowerCase()) {
						case 'input':
							let type = that.data.element.getAttribute('type');
							if (type === 'radio' || type === 'checkbox') {
								that.config.errors.forEach(err => err.classList.add('hidden'));
								that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
							}
						break;

						case 'select':
							that.config.errors.forEach(err => err.classList.add('hidden'));
							that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
						break;

						default: break;
					}
				// valid input, hide previously displayed error message
				} else if (e.detail.isValid && that.config.lastDisplayedError >= 0) {
					if (hintInitial) {
						hintInitial.classList.remove('hidden');
					}

					// leave this here, since animationstart will trigger a validationResult
					that.config.errors[that.config.lastDisplayedError].classList.add('hidden');
					that.config.lastDisplayedError = -1;
					errorContainer && errorContainer.removeAttribute('data-error');

					if (that.data.element.getAttribute('type') === 'hidden' && that.data.element.getAttribute('id').match(/.*-date/)) {
						that.data.element.closest('.js-compound-container').classList.remove('invalid-input');
					}

					let vu = await validUploads();
					if(formComponentsContainer && formComponentsContainer.querySelectorAll('.input__error-container[data-error]').length === 0 && vu) {
						formComponentsContainer.classList.remove('hide-hints');
					}
				} else if (that.data.element.getAttribute('type') === 'radio' && e.detail.isValid) {
					// radio buttons share error messages
					// -> one radio button can enable an error, the second doesn't know about it and will not reset error display
					that.config.errors.forEach(err => err.classList.add('hidden'));
					errorContainer && errorContainer.removeAttribute('data-error');

					if (hintInitial) {
						hintInitial.classList.remove('hidden');
					}
				}
			});

			// Remember the available errors, can be empty
			that.config.errors = Array.prototype.slice.call(
				parent.querySelectorAll('.input__error-container .error')
			);

			that.config.lastDisplayedError = -1;
			let hintOnFocus = parent.querySelector('.hint.hint--view-option-focus');

			if (that.data.element.nodeName.toLowerCase() !== 'select') {
				// If the element is not an input (ie textarea), or not a checkbox and not radio we have focus/blur events
				if (that.data.element.nodeName.toLowerCase() !== 'input' || that.data.element.getAttribute('type') !== 'checkbox' && that.data.element.getAttribute('type') !== 'radio') {
					// Display hint that is to be displayed on focus, unless error is displayed
					that.data.element.addEventListener('focus', e => {
						if (!!hintOnFocus && that.config.lastDisplayedError == -1) {  // we only need to check on focus, blur doesn't matter
							hintOnFocus.classList.remove('hint--view-option-focus');
						} else if (that.config.lastDisplayedError > -1) {
							that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
						}
					});
					that.data.element.addEventListener('blur', e => {
						if (!!hintOnFocus) {
							hintOnFocus.classList.add('hint--view-option-focus');
						}

						// if an input has multiple error messages,
						// lastDisplayedError will be changed sometime between blurStart and blurEnd, this might end up being a racecondition
						// hence simply hide any err
						that.config.errors.forEach(err => err.classList.add('hidden'));
					});
				} else {
					that.data.element.addEventListener('click', e => {
						if (!!hintOnFocus && that.config.lastDisplayedError == -1) {  // we only need to check on focus, blur doesn't matter
							hintOnFocus.classList.remove('hint--view-option-focus');
						} else if (that.config.lastDisplayedError > -1) {
							that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
						}
					});
				}
			} else {
				that.data.element.addEventListener('click', e => {
					if (!!hintOnFocus && that.config.lastDisplayedError == -1) {  // we only need to check on focus, blur doesn't matter
						hintOnFocus.classList.remove('hint--view-option-focus');
					} else if (that.config.lastDisplayedError > -1) {
						that.config.errors[that.config.lastDisplayedError].classList.remove('hidden');
					}
				});
			}
		};

		// Initialize Validation, but delay,
		// otherwise the select instantiation will trigger the first validation
		setTimeout(() => {
			let validations = Array.prototype.slice.call(document.querySelectorAll('[validate]'));
				validations.forEach(el => new Validation(el, initFunc));
		}, 500);

		// Compund Date logic, setting selected values into hidden input field
		let compoundDates = Array.prototype.slice.call(document.querySelectorAll('.js-compound-container'));
		compoundDates.forEach(el => {
			let hiddenInput = el.querySelector('input[type="hidden"]');
			let selects = Array.prototype.slice.call(el.querySelectorAll('select'));

			selects.forEach((el, i) => {
				el.addEventListener('change', select => {
					let optValue = select.target.value || select.currentTarget.value;

					let inp = hiddenInput.value.split('.');
						inp[i] = optValue < 10 ? `0${ optValue }` : optValue;
					hiddenInput.value = inp.join('.');
					// trigger a validation if all 3 selects were touched
					if (hiddenInput.hasAttribute('validate-trigger') && hiddenInput.value.match(/\d{2}\.\d{2}\.\d{4}/i)) {
						window.dispatchEvent(new CustomEvent(hiddenInput.getAttribute('validate-trigger')));
					}
				});
			});
		});

		// Is set in smf.index if damage route, otherwise set as undefined
		if (selectedDamage !== undefined) {
			this.config.currentStep = 1;
			this.tmpl.select(selectedDamage);
		}
	};
	this.main();
}]);

app.controller('ATMRobberyCtrl', [ '$timeout', function($timeout) {
	this.config = {
		lastValueInsuredPerson: undefined,
		maxFiles: 3,
	};
	this.data = {
		insuredPerson:		undefined,
		contractNumber:		undefined,
		cardNumber:			undefined,
		robberyDate:		undefined,
		amountWithdrawn:	undefined,
		caseDescription:	undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_geldAutomatenRaub');
		this.data.robberyDate = getVI('e_robbery_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_robbery_date').isValidInput(),
			getVI('e_amount_withdrawn').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('ATMRobberyCtrl_validate', this.validate);

		channel.register('ATMRobberyCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'ATMRobberyCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('BestPriceCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 3,
	};
	this.data = {
		insuredPerson: undefined,
		contractNumber: undefined,
		cardNumber: undefined,
		productBought: undefined,
		purchaseDate: undefined,
		purchasePrice: undefined,
		cheaperPlace: undefined,
		offerDate: undefined,
		cheaperPrice: undefined,
		priceDifference: undefined,
		additionalInformation: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_bestPreisVersicherung');
		this.data.purchaseDate = getVI('e_purchase_date').getCurrentValue();
		this.data.offerDate = getVI('e_product_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_product_bought').isValidInput(),
			getVI('e_purchase_date').isValidInput(),
			getVI('e_product_price').isValidInput(),
			getVI('e_cheaper_place').isValidInput(),
			getVI('e_product_date').isValidInput(),
			getVI('e_cheaper_price').isValidInput(),
			getVI('e_price_difference').isValidInput(),
			getVI('e_additional_information').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('BestPriceCtrl_validate', this.validate);

		channel.register('BestPriceCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'BestPriceCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('CreditFraudCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 3
	};
	this.data = {
		insuredPerson: undefined,
		misuseDate: undefined,
		amountStolen: undefined,
		caseDescription: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_kreditkartenMissbrauch');
		this.data.misuseDate = getVI('e_misuse_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_misuse_date').isValidInput(),
			getVI('e_amount_stolen').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('CreditFraudCtrl_validate', this.validate);

		channel.register('CreditFraudCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'CreditFraudCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('DisabilityCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 1
	};
	this.data = {
		insuredPerson: undefined,
		disabilityDate: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_arbeitsunfaehigkeit');
		this.data.disabilityDate = getVI('e_disability_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_disability_date').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('DisabilityCtrl_validate', this.validate);

		channel.register('DisabilityCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'DisabilityCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('FatalityCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 1,
	};
	this.data = {
		insuredPerson: undefined,
		deathDate: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_todesfall');
		this.data.deathDate = getVI('e_death_date').getCurrentValue();

		return [
			getVI('e_death_date').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('FatalityCtrl_validate', this.validate);

		channel.register('FatalityCtrl_insuredPerson', () => {
			return false;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'FatalityCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('PhishingCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 3,
	};
	this.data = {
		insuredPerson: undefined,
		contractNumber: undefined,
		cardNumber: undefined,
		phishingDate: undefined,
		amountStolen: undefined,
		caseDescription: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_phishingVersicherung');
		this.data.phishingDate = getVI('e_phishing_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_phishing_date').isValidInput(),
			getVI('e_amount_damage').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('PhishingCtrl_validate', this.validate);

		channel.register('PhishingCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'PhishingCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('RepairCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 2,
	};
	this.data = {
		insuredPerson: undefined,
		damageReportDate: undefined,
		productConcerned: undefined,
		purchaseDate: undefined,
		purchasePriceProductBought: undefined,
		caseDescription: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_reparaturVersicherung');
		this.data.damageReportDate = getVI('e_report_date').getCurrentValue();
		this.data.purchaseDate = getVI('e_purchase_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_report_date').isValidInput(),
			getVI('e_product_concerned').isValidInput(),
			getVI('e_purchase_date').isValidInput(),
			getVI('e_product_price').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('RepairCtrl_validate', this.validate);

		channel.register('RepairCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'RepairCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('IllnessCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 1,
	};
	this.data = {
		insuredPerson: undefined,
		sicknessDate: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_schwereKrankheit');
		this.data.sicknessDate = getVI('e_sickness_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_sickness_date').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('IllnessCtrl_validate', this.validate);

		channel.register('IllnessCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'IllnessCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('ShoppingCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFileTheft: 3,
		maxFileDamage: 2,
	};
	this.data = {
		insuredPerson: undefined,
		insuranceDate: undefined,
		damageNature: undefined,
		productConcerned: undefined,
		purchaseDate: undefined,
		purchasePrice: undefined,
		caseDescription: undefined,
		// file uploads are independent from this controller
	};

	/**
	 * Sets the state of ng variables.
	 * Triggers a digest cycle by using $timeout.
	 *
	 * @param	function	func	A function to execute.
	 * @param	integer		delay	Optional delay for when to exec func.
	 */
	this.setState = async(func, delay) => {
		return await $timeout((typeof(delay) !== 'undefined' ? delay : 0)).then(func);
	};

	this.tmpl = {
		selectDamage: selector => {
			let sel = document.querySelector(selector);
			if (sel) {
				this.setState(() => {
					this.data.damageNature = sel.options[sel.selectedIndex].value;
					let vt = sel.getAttribute('validate-trigger');
					if (vt) {
						window.dispatchEvent(new CustomEvent(vt));
					}
					preventHintOverflow();
				});
			}
		}
	};

	this.validate = async () => {
		// Conditionally used file uploads, if either of these is not used, the return value is true
		let fileUpload1 = await channel.notify('uploads_valid_einkaufsVersicherung_damage');
		let fileUpload2 = await channel.notify('uploads_valid_einkaufsVersicherung_robbery');

		// ng does not support ng-model on hidden fields
		this.data.insuranceDate = getVI('e_insurance_date').getCurrentValue();
		this.data.purchaseDate = getVI('e_purchase_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_insurance_date').isValidInput(),
			getVI('e_damage_nature').isValidInput(),
			getVI('e_product_concerned').isValidInput(),
			getVI('e_purchase_date').isValidInput(),
			getVI('e_product_price').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload1.length ? fileUpload1[0] : true ],
			...[ fileUpload2.length ? fileUpload2[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('ShoppingCtrl_validate', this.validate);

		channel.register('ShoppingCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'ShoppingCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('HandyCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 3,
	};
	this.data = {
		insuredPerson: undefined,
		contractNumber: undefined,
		cardNumber: undefined,
		insuranceDate: undefined,
		caseDescription: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_handyVersicherung');
		this.data.insuranceDate = getVI('e_insurance_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_insurance_date').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal, i) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('HandyCtrl_validate', this.validate);

		channel.register('HandyCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'HandyCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('TicketCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 3,
	};
	this.data = {
		insuredPerson: undefined,
		ticketDate: undefined,
		caseDescription: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_ticketVersicherung');
		this.data.ticketDate = getVI('e_ticket_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_ticket_date').isValidInput(),
			getVI('e_case_description').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ],
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('TicketCtrl_validate', this.validate);

		channel.register('TicketCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'TicketCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('UnemploymentCtrl', [ '$timeout', function($timeout) {
	this.config = {
		maxFiles: 4,
	};
	this.data = {
		insuredPerson: undefined,
		unemplyomentDate: undefined,
	};

	this.validate = async () => {
		let fileUpload = await channel.notify('uploads_valid_arbeitslosigkeit');
		this.data.unemplyomentDate = getVI('e_unemployment_date').getCurrentValue();

		return [
			getVI('e_insured_person_1').isValidInput(),
			getVI('e_unemployment_date').isValidInput(),
			...[ fileUpload.length ? fileUpload[0] : true ]
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('UnemploymentCtrl_validate', this.validate);

		channel.register('UnemploymentCtrl_insuredPerson', () => {
			return this.data.insuredPerson == 1;
		});

		channel.register('data_collection', () => {
			return { ctrl: 'UnemploymentCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('PersonalCtrl', [ '$timeout', '$http', '$q', function($timeout, $http, $q) {
	this.config = {
		autoCompleteQ: undefined,
		lastZipCheckSearch: undefined,
		lastZipCheckResponse: undefined,
		// some claims might not have bank information as necessity, that means, the bank partial isn't embedded
		// if it is embedded, it doesn't ng-init=true for this variable
		// but if the claiming person isn't the insured person the bank info isn't needed either - that one is dynamic
		displayBank: false,
		qDefer: undefined,
		lastChecked: undefined,
		lastCheckValid: false,
		checkingIban: false,
	};
	this.data = {
		salutation: undefined,
		firstName: 	undefined,
		lastName: 	undefined,
		street: 	undefined,
		zip: 		undefined,
		city: 		undefined,
		birthDay: 	undefined,
		phone:		undefined,
		mail:		undefined,
		iban:		undefined,
		bic:		undefined,
		bank:		undefined,
		sepa:		undefined,
	};

	/**
	 * Sets the state of ng variables.
	 * Triggers a digest cycle by using $timeout.
	 *
	 * @param	function	func	A function to execute.
	 * @param	integer		delay	Optional delay for when to exec func.
	 */
	this.setState = async(func, delay) => {
		return await $timeout((typeof(delay) !== 'undefined' ? delay : 0)).then(func);
	};

	this.tmpl = {
		pollIban: element => {
			if (this.data.iban === undefined || this.data.iban.length != 22) {
				return;
			}

			let ibanInput = document.querySelector(element);
				ibanInput.setAttribute('checking-iban', 'true');

			if (this.config.lastCheckValid && this.data.iban === this.config.lastChecked.iban) {
				this.setState(() => {
					this.data.bank = this.config.lastChecked.bank;
					this.data.bic = this.config.lastChecked.bic;

					ibanInput.setAttribute('checking-iban', 'false');
					setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_persCtrl'), 75));
				});

				return;
			}

			this.config.checkingIban = true;
			this.config.qDefer = $q.defer();
			$http({
				timeout: this.config.qDefer,
				method: 'GET',
				url: ROUTES.checkIban.replace('#iban#', this.data.iban),
				headers: {
					'X-CSRF-TOKEN': csrf_token
				}
			}).then(resp => {
				if (!resp.data.error) {
					this.setState(() => {
						this.data.bank = resp.data.data.bank;
						this.data.bic = resp.data.data.bic;

						this.config.lastCheckValid = true;
						this.config.lastChecked = { iban: this.data.iban, ...resp.data.data };

						ibanInput.setAttribute('valid-iban', 'true');
						ibanInput.setAttribute('checking-iban', 'false');

						this.config.checkingIban = false;
						setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_persCtrl'), 75));
					});
				} else {
					this.setState(() => {
						this.data.bank = undefined;
						this.data.bic = undefined;

						this.config.lastCheckValid = false;
						this.config.lastChecked = { iban: this.data.iban };

						ibanInput.setAttribute('valid-iban', 'false');
						ibanInput.setAttribute('checking-iban', 'false');

						this.config.checkingIban = false;
						setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_persCtrl'), 75));
					});
				}
			}).catch(resp => {
				this.setState(() => {
					this.data.bank = undefined;
					this.data.bic = undefined;

					this.config.lastCheckValid = false;
					this.config.lastChecked = { iban: this.data.iban };

					ibanInput.setAttribute('valid-iban', 'false');
					ibanInput.setAttribute('checking-iban', 'false');

					this.config.checkingIban = false;
					setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_persCtrl'), 75));
				});
			});
		},
		pollZipCode: (elZipInput, elCityInput) => {
			if (this.data.zip === undefined || this.data.zip.toString().length != 5) { return; }

			let zipInput = document.querySelector(elZipInput);
			let cityInput = document.querySelector(elCityInput);

			if (this.config.lastZipCheckResponse !== undefined && this.config.lastZipCheckResponse.length === 1
				&& this.config.lastZipCheckSearch === this.data.zip) {
				this.setState(() => {
					this.data.city = this.config.lastZipCheckResponse[0][1];

					let vCity = new Validation(cityInput);
					setTimeout(() => vCity.isValidInput(), 75);
				});

				return;
			}

			this.config.autoCompleteQ = $q.defer();
			$http({
				timeout: this.config.autoCompleteQ.promise,
				method: 'GET',
				url: ROUTES.zip.replace('#zip#', this.data.zip),
				headers: {
					'X-CSRF-TOKEN': csrf_token
				}
			}).then(resp => {
				this.config.lastZipCheckSearch = this.data.zip;

				if (!resp.data.error) {
					let oldCheck = this.config.lastZipCheckResponse != undefined ? this.config.lastZipCheckResponse[0][1] : undefined;
					if (this.data.city === undefined || this.data.city.length === 0 || oldCheck === this.data.city) {
						this.setState(() => {
							this.data.city = resp.data.cities[0][1];

							let vZip = new Validation(zipInput);
							let vCity = new Validation(cityInput);
							setTimeout(() => {
								vZip.isValidInput();
								vCity.isValidInput();
							}, 75);
						});
					}

					this.config.lastZipCheckResponse = resp.data.cities;

					return;
				}
			}).catch(resp => {
				// can be empty
			});
		},
		select: selector => {
			let sel = document.querySelector(selector);
			if (sel) {
				this.setState(() => {
					this.data.salutation = sel.options[sel.selectedIndex].value;
					let vt = sel.getAttribute('validate-trigger');
					if (vt) {
						window.dispatchEvent(new CustomEvent(vt));
					}
				});
			}
		}
	};

	this.validate = async () => {
		if (this.config.checkingIban) { return false; }
		this.data.birthDay = getVI('e_birthday_personal').getCurrentValue();

		return [
			getVI('e_salutation_personal').isValidInput(),
			getVI('e_firstName_personal').isValidInput(),
			getVI('e_lastName_personal').isValidInput(),
			getVI('e_street_personal').isValidInput(),
			getVI('e_zip_personal').isValidInput(),
			getVI('e_city_personal').isValidInput(),
			getVI('e_birthday_personal').isValidInput(),
			getVI('e_phone_personal').isValidInput(),
			getVI('e_mail_personal').isValidInput(),
			this.config.displayBank ? getVI('e_sepa_persCtrl').isValidInput() : true,
			this.config.displayBank ? getVI('e_iban_persCtrl').isValidInput() && this.config.lastCheckValid : true
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('PersonalCtrl_validate', this.validate);

		let iban = document.querySelector('[id$="iban_persCtrl"]');
		if (iban) {
			channel.register('PersonalCtrl_displayBank', visible => {
				this.setState(() => {
					this.config.displayBank = visible;
					if (!visible) {
						this.data.iban = undefined;
						this.data.bic = undefined;
						this.data.bank = undefined;
						this.data.sepa = undefined;
						// If we're hiding, we need to hide any displayed error
						getVI('e_iban_persCtrl').reset();
						getVI('e_sepa_persCtrl').reset();
					}
				});
			});
		}

		channel.register('data_collection', () => {
			return { ctrl: 'PersonalCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('InsuredPersonCtrl', [ '$timeout', '$http', '$q', function($timeout, $http, $q) {
	this.config = {
		autoCompleteQ: undefined,
		lastZipCheckSearch: undefined,
		lastZipCheckResponse: undefined,

		// some claims might not have bank information as necessity for PersonalCtrl but for this
		displayBank: false,
		qDefer: undefined,
		lastChecked: undefined,
		lastCheckValid: false,
		checkingIban: false,
	};
	this.data = {
		salutation: undefined,
		firstName: 	undefined,
		lastName: 	undefined,
		street: 	undefined,
		zip: 		undefined,
		city: 		undefined,
		birthDay: 	undefined,
		phone:		undefined,
		mail:		undefined,
		iban:		undefined,
		bic:		undefined,
		bank:		undefined,
		sepa:		undefined,
	};

	/**
	 * Sets the state of ng variables.
	 * Triggers a digest cycle by using $timeout.
	 *
	 * @param	function	func	A function to execute.
	 * @param	integer		delay	Optional delay for when to exec func.
	 */
	this.setState = async(func, delay) => {
		return await $timeout((typeof(delay) !== 'undefined' ? delay : 0)).then(func);
	};

	this.tmpl = {
		pollIban: element => {
			if (this.data.iban === undefined || this.data.iban.length != 22) {
				return;
			}

			let ibanInput = document.querySelector(element);
				ibanInput.setAttribute('checking-iban', 'true');

			if (this.config.lastCheckValid && this.data.iban === this.config.lastChecked.iban) {
				this.setState(() => {
					this.data.bank = this.config.lastChecked.bank;
					this.data.bic = this.config.lastChecked.bic;

					ibanInput.setAttribute('checking-iban', 'false');
					setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_insCtrl'), 75));
				});

				return;
			}

			this.config.checkingIban = true;
			this.config.qDefer = $q.defer();
			$http({
				timeout: this.config.qDefer,
				method: 'GET',
				url: ROUTES.checkIban.replace('#iban#', this.data.iban),
				headers: {
					'X-CSRF-TOKEN': csrf_token
				}
			}).then(resp => {
				if (!resp.data.error) {
					this.setState(() => {
						this.data.bank = resp.data.data.bank;
						this.data.bic = resp.data.data.bic;

						this.config.lastCheckValid = true;
						this.config.lastChecked = { iban: this.data.iban, ...resp.data.data };

						ibanInput.setAttribute('valid-iban', 'true');
						ibanInput.setAttribute('checking-iban', 'false');

						this.config.checkingIban = false;
						setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_insCtrl'), 75));
					});
				} else {
					this.setState(() => {
						this.data.bank = undefined;
						this.data.bic = undefined;

						this.config.lastCheckValid = false;
						this.config.lastChecked = { iban: this.data.iban };

						ibanInput.setAttribute('valid-iban', 'false');
						ibanInput.setAttribute('checking-iban', 'false');

						this.config.checkingIban = false;
						setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_insCtrl'), 75));
					});
				}
			}).catch(resp => {
				this.setState(() => {
					this.data.bank = undefined;
					this.data.bic = undefined;

					this.config.lastCheckValid = false;
					this.config.lastChecked = { iban: this.data.iban };

					ibanInput.setAttribute('valid-iban', 'false');
					ibanInput.setAttribute('checking-iban', 'false');

					this.config.checkingIban = false;
					setTimeout(() => window.dispatchEvent(new CustomEvent('e_iban_insCtrl'), 75));
				});
			});
		},
		pollZipCode: (elZipInput, elCityInput) => {
			if (this.data.zip === undefined || this.data.zip.toString().length != 5) { return; }

			if (this.config.lastZipCheckResponse !== undefined && this.config.lastZipCheckResponse.length === 1
				&& this.config.lastZipCheckSearch === this.data.zip) {
				this.setState(() => this.data.city = this.config.lastZipCheckResponse[0][1]);

				return;
			}

			let zipInput = document.querySelector(elZipInput);
			let cityInput = document.querySelector(elCityInput);
			this.config.autoCompleteQ = $q.defer();
			$http({
				timeout: this.config.autoCompleteQ.promise,
				method: 'GET',
				url: ROUTES.zip.replace('#zip#', this.data.zip),
				headers: {
					'X-CSRF-TOKEN': csrf_token
				}
			}).then(resp => {
				this.config.lastZipCheckSearch = this.data.zip;

				if (!resp.data.error) {
					let oldCheck = this.config.lastZipCheckResponse != undefined ? this.config.lastZipCheckResponse[0][1] : undefined;
					if (this.data.city === undefined || this.data.city.length === 0 || oldCheck === this.data.city) {
						this.setState(() => {
							this.data.city = resp.data.cities[0][1];

							let vZip = new Validation(zipInput);
							let vCity = new Validation(cityInput);
							setTimeout(() => {
								vZip.isValidInput();
								vCity.isValidInput();
							}, 75);
						});
					}

					this.config.lastZipCheckResponse = resp.data.cities;

					return;
				}
			}).catch(resp => {
				// can be empty
			});
		},
		select: selector => {
			let sel = document.querySelector(selector);
			if (sel) {
				this.setState(() => {
					this.data.salutation = sel.options[sel.selectedIndex].value;
					let vt = sel.getAttribute('validate-trigger');
					if (vt) {
						window.dispatchEvent(new CustomEvent(vt));
					}
				});
			}
		}
	};

	this.validate = async () => {
		this.data.birthDay = getVI('e_birthday_insured').getCurrentValue();
		
		return [
			getVI('e_salutation_insured').isValidInput(),
			getVI('e_firstName_insured').isValidInput(),
			getVI('e_lastName_insured').isValidInput(),
			getVI('e_street_insured').isValidInput(),
			getVI('e_zip_insured').isValidInput(),
			getVI('e_city_insured').isValidInput(),
			getVI('e_birthday_insured').isValidInput(),
			// Todesfall has no mail/phone display
			...[
				selectedDamage !== 'todesfall' ? getVI('e_phone_insured').isValidInput() : true
			],
			...[
				selectedDamage !== 'todesfall' ? getVI('e_mail_insured').isValidInput() : true
			],
			this.config.displayBank ? getVI('e_sepa_insCtrl').isValidInput() : true,
			this.config.displayBank ? getVI('e_iban_insCtrl').isValidInput() && this.config.lastCheckValid : true
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('InsuredPersonCtrl_validate', this.validate);

		let iban = document.querySelector('[id$="iban_insCtrl"]');
		if (iban) {
			channel.register('InsuredPersonCtrl_displayBank', visible => {
				this.setState(() => {
					this.config.displayBank = visible;

					if (!visible) {
						this.data.iban = undefined;
						this.data.bic = undefined;
						this.data.bank = undefined;
						this.data.sepa = undefined;
						// If we're hiding, we need to hide any displayed error
						getVI('e_iban_insCtrl').reset();
						getVI('e_sepa_insCtrl').reset();
					}
				});
			});
		}

		channel.register('data_collection', () => {
			return { ctrl: 'InsuredPersonCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.controller('ConsentCtrl', [ '$timeout', '$http', '$q', function($timeout, $http, $q) {
	this.data = {
		privacy: undefined,
		obligations: undefined,
	};

	this.validate = async () => {
		return [
			getVI('e_checkbox_privacy').isValidInput(),
			getVI('e_checkbox_obligations').isValidInput(),
		].reduce(function(prevVal, curVal) {
			if (curVal === false) { prevVal = false; }

			return prevVal;
		}, true);
	};

	this.main = () => {
		channel.register('ConsentCtrl_validate', this.validate);

		channel.register('data_collection', () => {
			return { ctrl: 'ConsentCtrl', data: this.data };
		});
	};
	this.main();
}]);

app.directive('fileUpload', [ '$timeout', function($timeout) {
    return {
        restrict: 'A',
        replace: true,
        scope: {
			maxFiles: '@',
			url: '@',
			accept: '@',
			fileTemplate: '@',
			identifier: '@',
			required: '@',
			used: '@'
		},
		controllerAs: 'ctrl',
		controller: function($scope, $transclude) {
			let ctrl = this;
			ctrl.element = undefined,
			ctrl.dropzone = undefined;

			let elDefaultMessage;  // set in init, as only then ctrl.element was set
			let elMoreFiles;
			let toggleDisplayedMessage = visible => {
				if (!elDefaultMessage || !elMoreFiles) { return; }

				if (typeof(visible) !== 'undefined' && visible === true) {
					elMoreFiles.classList.add('hidden');
					elDefaultMessage.classList.remove('hidden');
				} else {
					elDefaultMessage.classList.add('hidden');
					elMoreFiles.classList.remove('hidden');
				}
			};

			let elErrors, elParentContainer, elErrorMessage;
			let toErr = undefined;
			let funcRemoveErrMsg = () => {
				clearTimeout(toErr);
				toErr = setTimeout(() => {
					elErrors.classList.add('hidden');
					elErrors.innerHTML = '';
				}, 5000);
			};
			let toggleErrorMessage = text => {
				if (!elErrors) { return; }

				let form = ctrl.element.closest('.form-components-container');
				if (typeof(text) === 'undefined' || text === null) {
					elErrors.classList.add('hidden');
					elErrors.innerHTML = '';

					// Hide potentially displayed error next to file upload field
					// Also, hide potentially the hidden hints if this was the last error
					$scope.required && elErrorMessage && elErrorMessage.classList.add('hidden');
					if (form.querySelectorAll('.error:not(.hidden)').length === 0) {
						form.classList.remove('hide-hints');
					}
				} else {
					elErrors.classList.remove('hidden');
					elErrors.innerHTML = text;
					funcRemoveErrMsg();
				}
			};

			this.config = {
				// via use attribute we can temporarily "disable" this fileupload
				// in that case the fileupload is moved away out of viewport - not hidden as it breaks validation
				// if this is false, the validation must return true, fileuplodas must not be executed
				currentlyUsed: true,

				showExceedingFileSizeNotice: false,
				showWrongFileTypeNotice: false,
				showDuplicateFileNotice: false,
				uploading: false,
				uploadError: false,
				failedFiles: [],
				formData: null,

				defaultMessageContainer: undefined,
				moreFilesContainer: undefined,
				dzConfig: {
					url: $scope.url,
					maxFiles: parseInt($scope.maxFiles) || 1,
					maxFileSize: 2,
					parallelUploads: 1,
					uploadMultiple: true,
					acceptedFiles: $scope.accept || 'application/pdf',
					createImageThumbnails: false,
					addRemoveLinks: true,
					autoProcessQueue: false, //myDropzone.processQueue()
					autoQueue: true,
					previewTemplate: document.body.querySelector($scope.fileTemplate).innerHTML,
					dictDefaultMessage: __UPLOAD.dictDefaultMessage || null,
					dictFallbackMessage: __UPLOAD.dictFallbackMessage || null,
					dictFallbackText: __UPLOAD.dictFallbackText || null,
					dictFileTooBig: __UPLOAD.dictFileTooBig || null,
					dictInvalidFileType: __UPLOAD.dictInvalidFileType || null,
					dictResponseError: __UPLOAD.dictResponseError || null,
					dictRemoveFile: __UPLOAD.dictRemoveFile || null,
					dictMaxFilesExceeded: '',  // if null, dz tries to replace('{{maxFiles}}') on null...
					dictDuplicateFile:	__UPLOAD.dictDuplicateFile || null,
					headers: {
						'X-CSRF-TOKEN': csrf_token,
						'X-GLOBALID': __GLOBALID
					},
					init: function() {
						elParentContainer = ctrl.element.closest('.input__container');
						elErrorMessage = elParentContainer.querySelector('.input__error-container .error');

						// General check for thie hide-hint feature
						channel.register(`uploads_valid`, () => {
							if (!ctrl.config.currentlyUsed) { return true; }

							return $scope.required ? this.files.length > 0 : true;
						});
						// more specific, does set the necessary classes
						channel.register(`uploads_valid_${ $scope.identifier }`, () => {
							if (!ctrl.config.currentlyUsed) { return true; }

							let valid = $scope.required ? this.files.length > 0 : true;
							if (valid === true) {
								elParentContainer.classList.remove('invalid-input');
								elParentContainer.classList.add('valid-input');
								elErrorMessage && elErrorMessage.classList.add('hidden');
							} else if (valid === false) {
								elParentContainer.classList.add('invalid-input');
								elParentContainer.classList.remove('valid-input');
								elErrorMessage && elErrorMessage.classList.remove('hidden');

								// Hide hints for all inputs
								let form = ctrl.element.closest('.form-components-container');
								form && form.classList.add('hide-hints');
							}

							return valid;
						});

						channel.register('upload_files', () => {
							if (!ctrl.config.currentlyUsed) {
								return 0;
							} else {
								// processing queue immediately decreases queuedFiles count
								let filesToUpload = ctrl.dropzone.getQueuedFiles().length;
								if (filesToUpload > 0) {
									setTimeout(() => {
										ctrl.config.uploading = true;
										ctrl.dropzone.processQueue();
									}, 0);
								}

								return filesToUpload;
							}
						});

						elErrors = ctrl.element.parentNode.querySelector('.js-file-errors');
						elDefaultMessage = ctrl.element.querySelector('.js-default-message');
						elMoreFiles = ctrl.element.parentNode.querySelector('.js-more-files');  // parentNode to be more flexible with this element

						if (elMoreFiles) {
							elMoreFiles.addEventListener('click', () => {
								ctrl.dropzone.hiddenFileInput.click();
							});
						}

						ctrl.config.defaultMessageContainer = ctrl.element.querySelector('.js-default-message');
						ctrl.config.moreFilesContainer = ctrl.element.querySelector('.js-more-files');

						this.on('error', function(file, errorMessage, xhr) {
							// if the maximum of files that are allowed for upload are exceeded,
							// each additional file raises this issue with an undef xhr
							if (xhr !== undefined) {
								ctrl.dropzone.removeFile(file);

								// Try to upload other files until queue is done
								if (ctrl.dropzone.getQueuedFiles().length > 0) {
									ctrl.dropzone.processQueue();
								}
							}
						});
						this.on('success', function(file, response) {
							$(file.previewElement).find('.dz-remove').remove();
							ctrl.dropzone.options.autoProcessQueue = true;

							channel.notify('file_upload_done', file);
						});
						this.on('sending', function(file, xhr, formData) {
							channel.notify('file_upload_sending', file);
						});
						this.on('queuecomplete', function() {
							ctrl.dropzone.options.autoProcessQueue = false;
							ctrl.config.uploading = false;

							channel.notify('file_upload_completed');
						});

						let accF = ctrl.config.dzConfig.acceptedFiles.split(',');
							accF = new RegExp(`(${ accF.map(el => el.replace('.', '\\.').trim()).join('|') })$`, 'i');
						// removing duplicate removes selectedFiles entry -> prevent with this state var
						let removeDuplicateFile = false;
						this.on('addedfile', function(file) {
							if (!file.name.match(accF)) {
								toggleErrorMessage(ctrl.config.dzConfig.dictInvalidFileType);
								ctrl.dropzone.removeFile(this.files[this.files.length-1]);
							} else if (this.files.length > ctrl.config.dzConfig.maxFiles) {
								toggleErrorMessage(ctrl.config.dzConfig.dictMaxFilesExceeded);
								ctrl.dropzone.removeFile(this.files[this.files.length-1]);
							} else if (file.size / 1048576 > ctrl.config.dzConfig.maxFileSize) {
								toggleErrorMessage(ctrl.config.dzConfig.dictFileTooBig);
								ctrl.dropzone.removeFile(this.files[this.files.length-1]);
							} else if (typeof(ctrl.config.selectedFiles[`${ file.name }_${ file.size }`]) !== 'undefined') {
								toggleErrorMessage(ctrl.config.dzConfig.dictDuplicateFile);
								removeDuplicateFile = true;
								ctrl.dropzone.removeFile(this.files[this.files.length-1]);
							} else {
								ctrl.config.selectedFiles[`${ file.name }_${ file.size }`] = file;

								channel.notify(`uploads_valid_${ $scope.identifier }`);
								toggleErrorMessage();
								toggleDisplayedMessage(false);

								tag.push(`upload_${ selectedProduct }_${ selectedDamage }`);
							}
						});

						this.on('removedfile', function(file) {
							if (removeDuplicateFile) {
								removeDuplicateFile = false;
								return;
							} else if (!ctrl.config.currentlyUsed) {
								return;
							}

							ctrl.config.selectedFiles[`${ file.name }_${ file.size }`] = undefined;
							if (this.files.length === 0) {
								toggleDisplayedMessage(true);
								let form = ctrl.element.closest('.form-components-container');
								form && form.classList.add('hide-hints');
								channel.notify(`uploads_valid_${ $scope.identifier }`);
							}
						});
					}
				},
				selectedFiles: {
					/*
						filename_filesize: 1
						Mapper to check if a file was added already
					*/
				}
			}

			// If we do not (temporarily) use a fileupload, we need to move it out of the form to "hide" it
			// we cannot hide it or we break the validation same for ng-if
			this.setUsage = used => {
				let container = ctrl.element.closest('.js-container-upload');
				if (container) {
					let form = ctrl.element.closest('.form-components-container');
					if (used == 'true') {
						container.classList.remove('inactive-upload');
						this.config.currentlyUsed = true;

						// Setting upload visible - is form in error state? add error state to empty upload
						// but only if this is a required field
						if (form && form.classList.contains('hide-hints') && $scope.required) {
							elParentContainer.classList.add('invalid-input');
							elParentContainer.classList.remove('valid-input');
							elErrorMessage && elErrorMessage.classList.remove('hidden');
						}
					} else if (used == 'false') {
						this.config.currentlyUsed = false;

						container.classList.add('inactive-upload');
						this.config.selectedFiles = {};
						// Reset dropzone and error state(s)
						ctrl.dropzone.removeAllFiles();
						// reset error state of input, we decide to display it above again
						elParentContainer.classList.remove('invalid-input');
						elParentContainer.classList.add('valid-input');
						elErrorMessage && elErrorMessage.classList.add('hidden');

						elMoreFiles.classList.add('hidden');
						elDefaultMessage.classList.remove('hidden');
					}
				}
			};
		},
        link: function (scope, element, attrs, ctrl, $transclude) {
			ctrl.element = element[0];
			ctrl.dropzone = new Dropzone(element[0], ctrl.config.dzConfig);

			// We watch used only if provided as attribute,
			// otherwise we will not watch it,
			// so dynamically adding in use is not supported for simplicity and performance reasons
			if (attrs.used !== undefined) {
				scope.$watch('used', function(newVal, oldVal) {
					ctrl.setUsage(newVal);
				});
			}
        }
    };
}]);
